import styles from "./mortgageRepaymentResult.module.css";
import GetMonthlyPayment from "../../../helpers/monthlyPayment";
import GetTotalInterestTime from "../../../helpers/totalInterestTime";

const MortgageRepaymentResult = ({ loan, extra, year, rate }) => {
  let totalInterest = 0;

  const monthlyPay = () => {
    if (
      loan === 0 ||
      loan === "" ||
      year === 0 ||
      year === "" ||
      rate === 0 ||
      rate === ""
    )
      return "";

    const pay = GetMonthlyPayment(loan, rate, year);
    let payInterestTime = GetTotalInterestTime(loan, rate, year, Number(extra));
    totalInterest = payInterestTime.totalInterest;
    return Number(pay) + Number(extra);
  };

  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

  return (
    <div className={styles.result_view}>
      <div className="col-m-6">
        <label className={`form-label ${styles.label_main}`}>
          Current Monthly Payment
        </label>
        <div className={styles.payment}>{USDollar.format(monthlyPay())}</div>
      </div>
      <hr className={styles.hr} />
      <div className={`col-m-6 ${styles.total_wrapper}`}>
        <div className={styles.gapper}>
          <label className={`form-label ${styles.label}`}>Total Principal</label>
          <div className={styles.principal}>
            {loan !== "0" ? USDollar.format(loan).toString() : ""}
          </div>
        </div>
        <div>
          <label className={`form-label ${styles.label}`}>Total Interest</label>
          <div className={styles.interest}>
            {USDollar.format(totalInterest).toString()}
          </div>
        </div>
      </div>
      <hr className={styles.hr} />

      {/* Get Started Button */}
      <a
        href="https://www.mortgagematrix.com.au/apply"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.linkWrapper}
      >
        <button className={styles.infoButton}>
        Suggested Lenders <span className={styles.arrow}>→</span>
        </button>
      </a>

      <div className={styles.disclaimer}>
        If you choose a home loan with one of our panel of lenders, your savings
        may vary based on your specific home loan.
      </div>
    </div>
  );
};

export default MortgageRepaymentResult;
